import { HomeLayout } from '@/theme/default/layouts'

/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = [
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  // {
  //     path: '/',
  //     name: 'home',
  //     redirect: '/home',
  //     component: HomeLayout,
  //     children: [
  //         {
  //             path: 'home',
  //             name: 'homeIndex',
  //             component: () => import('@/theme/default/views/home/Home')
  //         }
  //     ]
  // },
  //考试
  {
    path: '/examine',
    name: 'examine',
    component: () => import('@/components/exam/Examine')
  },
  //试卷预览
  {
    path: '/paperPreview',
    name: 'paperPreview',
    component: () => import('@/views/exam/PaperPreview'),
    meta: { title: '模拟测试', name: '试卷中心' }
  },
  //学生答卷预览
  {
    path: '/userPaperPreview',
    name: 'userPaperPreview',
    component: () => import('@/views/exam/UserPaperPreview')
  },
  //学生答卷批改
  {
    path: '/examReview',
    name: 'examReview',
    component: () => import('@/views/exam/ExamReview'),
  },
  //组卷
  {
    path: '/composing',
    name: 'paperComposing',
    component: () => import('@/components/exam/PaperComposing'),
  },
  //文件预览
  {
    path: '/fileView',
    name: 'fileView',
    component: () => import('@/components/common/FileView')
  },
  //AI聊天
  {
    path: '/aichat',
    name: 'aichat',
    component: () => import('@/components/tools/AIChat')
  },
  //试卷报告
  {
    path: '/paperReport',
    name: 'paperReport',
    component: () => import('@/views/exam/PaperReport'),
  },
  //课堂学员列表
  {
    path: '/classStudent',
    name: 'classStudent',
    component: () => import('@/components/course/ClassStudentList'),
  },
  //课堂老师评价
  {
    path: '/teacherPhotoReview',
    name: 'teacherPhotoReview',
    component: () => import('@/components/course/TeacherPhotoReview')
  },
  //作品详情
  {
    path: '/workDetail',
    name: 'workDetail',
    component: () => import('@/components/work/WorkDetail')
  },
  //成长相册
  {
    path: '/studentPhoto',
    name: 'studentPhoto',
    component: () => import(/* webpackChunkName: "wuge" */ '@/components/report/TimelinePhoto'),
  },
]
